<template>
  <v-row no-gutters justify="center" align="center" style="height: 100vh;">
    <v-col cols="auto">
      <v-fade-transition>
        <div style="width: 100%; height: 680px;" v-if="page === 0">
          <timer-details :direction="direction" @next="goToTimer($event)"></timer-details>
        </div>
        <div style="width: 100%; height: 760px;" v-if="page === 1">
          <timer-counter
              :time="totalTimeAsMilliseconds"
              :direction="direction"
              @prev="returnToDetails()"
          ></timer-counter>
        </div>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import TimerDetails from "@/views/Tools/GeneralTools/Components/TimerDetails";
import TimerCounter from "@/views/Tools/GeneralTools/Components/TimerCounter";
import UrlParserMixin from "@/mixins/UrlParserMixin";

export default {
  name: "Timer",
  mixins: [UrlParserMixin],
  components: {
    TimerDetails,
    TimerCounter,
  },
  props: {
    direction: {
      type: String,
      default: 'down',
    },
  },
  computed: {
    totalTimeAsMilliseconds() {
      return (this.details.hours * 3600000) + (this.details.minutes * 60000) + (this.details.seconds * 1000);
    },
  },
  data: () => ({
    page: 0,
    details: {},
  }),
  methods: {
    goToTimer(details) {
      this.details = details;
      this.page++;
    },
    returnToDetails() {
      this.details = {};
      this.page--;
    },
  },
  mounted() {
  },
  watch: {
    direction() {
      this.page = 0;
    },
  },
}
</script>

<style scoped>

</style>